import { SystemAdminNotification } from "src/globalTypes";
import { action, fsa } from "ts-action";

export const receiveSystemAdminNotifications = action(
  "NOTIFICATIONS : SYSTEM ADMIN > GET MESSAGES > RECEIVE (signalR)", // aby bylo v devtools jasnější, že se to může dispatchnout i bez requestu
  fsa<{ notifications: SystemAdminNotification[] }>()
);
